import React, { CSSProperties, memo } from 'react';
import classNames from 'classnames';

import { UiInnerNotSPALink } from 'src/components/UI/InnerNotSPALink';
import { UiOuterLink } from 'src/components/UI/OuterLink';
import { resources } from 'src/config/resources';
import { BrandingModelSelectorType } from 'src/models/Branding/BrandingModel';
import { numberOrDefaultNumber } from 'src/utils/numbers';
import { normalizeSchemaUrl } from 'src/utils/url';

type BrandLogoProps = {
  brandingModel: BrandingModelSelectorType;

  hideRallyUpLogo?: boolean;
  className?: string;
  noClassImage?: boolean;
};

export const BrandLogo: React.FC<BrandLogoProps> = memo(
  ({ brandingModel, hideRallyUpLogo, className, noClassImage }: BrandLogoProps) => {
    const logoStyle: CSSProperties = React.useMemo(
      () => ({
        maxHeight: numberOrDefaultNumber(brandingModel.data.LogoHeight, 40),
      }),
      [brandingModel.data.LogoHeight]
    );

    if (brandingModel.loading || (brandingModel.data.BrandLogoUri && hideRallyUpLogo)) {
      return null;
    }

    const linkClasses = className || 'logo';

    return brandingModel.data.BrandLogoUri ? (
      <UiOuterLink
        className={linkClasses}
        href={normalizeSchemaUrl(brandingModel.data.HeaderLogoLink || '')}
        style={logoStyle}
      >
        <img src={brandingModel.data.BrandLogoUri} alt="" loading="lazy" />
      </UiOuterLink>
    ) : (
      <UiInnerNotSPALink className={linkClasses} href="" style={logoStyle}>
        <img
          src={resources.images.appDefaultLogo}
          className={classNames({ 'brand-logo img-fluid': !noClassImage })}
          alt=""
        />
      </UiInnerNotSPALink>
    );
  }
);
